import { Modal, Typography, message } from 'antd';
import tw from 'twin.macro';

import { useUpdateOrderStatus } from '@/hooks/mutations/admin';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  orderId: number;
  onSuccess: () => void;
}

const CancelOrderModal = ({ onClose, onSuccess, isOpen, orderId }: Props) => {
  const updateOrderStatus = useUpdateOrderStatus({
    onSuccess: () => {
      message.success('정상적으로 취소됐어요');
      onSuccess();
      onClose();
    },
  });

  return (
    <Modal
      centered
      width={320}
      open={isOpen}
      onClose={onClose}
      onCancel={onClose}
      onOk={() => {
        updateOrderStatus.mutate({
          id: orderId,
          status: 'CANCELLED',
        });
      }}
      okText="네 취소할게요"
      title="신청 취소"
    >
      <Typography.Text type="secondary">
        상품 신청 내역을 취소하시겠어요?
      </Typography.Text>
    </Modal>
  );
};

export default CancelOrderModal;
